/* Nyjlo — lightweight behaviour. No libraries. Deferred. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Rotating usage word -------------------------------------- */
  function rotator(root) {
    var slot = root.querySelector('[data-rot-word]');
    if (!slot || root.dataset.nyjloInit === '1') return;
    root.dataset.nyjloInit = '1';
    var words;
    try { words = JSON.parse(root.getAttribute('data-rot-words') || '[]'); } catch (e) { words = []; }
    if (!Array.isArray(words) || words.length < 2) return;

    // Reserve width so the line never reflows or wraps as words swap.
    var probe = document.createElement('span');
    probe.style.cssText = 'position:absolute;visibility:hidden;white-space:nowrap';
    probe.className = slot.className;
    root.appendChild(probe);
    var max = 0;
    words.forEach(function (w) { probe.textContent = w; max = Math.max(max, probe.offsetWidth); });
    probe.remove();
    if (max) slot.style.minWidth = Math.ceil(max) + 'px';

    if (reduce) return;                         // static first word
    var i = 0;
    setInterval(function () {
      slot.classList.add('is-out');
      setTimeout(function () {
        i = (i + 1) % words.length;
        slot.textContent = words[i];
        slot.classList.remove('is-out');
      }, 300);
    }, 2600);
  }

  /* ---- 2. Product gallery (swipe + thumbnails) --------------------- */
  function gallery(root) {
    var slides = root.querySelector('[data-gal-slides]');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-gal-thumb]'));
    if (!slides || !thumbs.length || root.dataset.nyjloInit === '1') return;
    root.dataset.nyjloInit = '1';

    function go(i) {
      var slide = slides.children[i];
      if (!slide) return;
      slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { go(i); });
    });

    var sync = function () {
      var idx = Math.round(slides.scrollLeft / slides.clientWidth);
      thumbs.forEach(function (b, i) { b.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    };
    var t;
    slides.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); }, { passive: true });
    sync();
  }

  /* ---- 3. Quantity stepper ----------------------------------------- */
  function qty(root) {
    var input = root.querySelector('input[name="quantity"]');
    if (!input || root.dataset.nyjloInit === '1') return;
    root.dataset.nyjloInit = '1';
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var step = parseInt(btn.getAttribute('data-qty-step'), 10) || 0;
      var min = parseInt(input.min, 10) || 1;
      var next = (parseInt(input.value, 10) || min) + step;
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---- 4. Sticky buy bar ------------------------------------------- */
  /* Shows once the main Add to Cart has scrolled past, and reserves the same
     height at the bottom of the page so it never covers footer content.     */
  function stickyBar() {
    var bar = document.querySelector('[data-sticky-buy]');
    var anchor = document.querySelector('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;

    function setSpace(on) {
      document.body.style.paddingBottom = on ? bar.offsetHeight + 'px' : '';
    }

    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top < 0;
        bar.classList.toggle('is-on', show);
        setSpace(show);
      });
    }, { threshold: 0 }).observe(anchor);

    window.addEventListener('resize', function () {
      if (bar.classList.contains('is-on')) setSpace(true);
    }, { passive: true });
  }

  /* ---- 5. Reveal on scroll ----------------------------------------- */
  function reveals() {
    var els = document.querySelectorAll('.n-reveal:not(.is-in)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    document.querySelectorAll('[data-rot]').forEach(rotator);
    document.querySelectorAll('[data-gal]').forEach(gallery);
    document.querySelectorAll('[data-qty]').forEach(qty);
    stickyBar();
    reveals();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  // Re-init when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', init);
})();
